module.exports = __webpack_public_path__ + "static/media/services-fullcycle-cycle-bg-2.32f8a5ab.svg";